import {makeAutoObservable} from 'mobx';
import CountyLinkAgent from '../agent/county-link-agent';
import {CountyLinkResource} from '../../entity/resource/county-link-resource';

export default class CountyLinkStore {
  countyLinkAgent: CountyLinkAgent;

  constructor(countyLinkAgent: CountyLinkAgent) {
    makeAutoObservable(this);
    this.countyLinkAgent = countyLinkAgent;
  }

  getCountyLinks = async (countyId: string): Promise<CountyLinkResource | undefined> => {
    try {
      const response = await this.countyLinkAgent.getCountyLinks(countyId);
      if (response.length > 0 && response[0].active)
        return response[0];
    } catch (error: any) {
      console.error('Error occurred while loading the county links', error);
    }
  }
}
